<script setup lang="ts">
import { computed } from 'vue';
import UiClampedText from '@/modules/ui/components/ui/UiClampedText.vue';
import { useDocumentMask } from '@/modules/document/composables/use-document-mask.ts';
import { escapeMarkdown } from '@/modules/common/utils/escape-markdown.util.ts';

const { text, mask } = defineProps<{
  text: string;
  mask: string | null;
  onlyMouse?: boolean;
}>();

const contentList = useDocumentMask(
  () => text,
  () => mask
);

const markdown = computed(() => {
  if (!contentList.value) {
    return escapeMarkdown(text);
  }

  return contentList.value
    .map((item, index) => (index % 2 === 0 ? escapeMarkdown(item) : `**${escapeMarkdown(item)}**`))
    .join('');
});
</script>

<template>
  <UiClampedText
    :markdown="markdown"
    :text="text"
    :only-mouse="onlyMouse"
  />
</template>
